require("bootstrap");
require("./sitio");

$(".btn-piso-1").on("click", function () {
    $('.img-piso-1').addClass('activo');
    $('.img-piso-2').removeClass('activo');

    $('.btn-piso-1').addClass('activo');
    $('.btn-piso-2').removeClass('activo');
});
$(".btn-piso-2").on("click", function () {
    $('.img-piso-2').addClass('activo');
    $('.img-piso-1').removeClass('activo');

    $('.btn-piso-2').addClass('activo');
    $('.btn-piso-1').removeClass('activo');

});


